import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';

import { typedApiClient } from '~/common/util/api-client';
import { AuditHistorySections } from '~/pages/AuditHistory/AuditHistoryAccordion';
import Layout from '~/pages/AuditHistory/Layout';
import { PageTitleMap } from '~/pages/AuditHistory/constants';
import { CalculatorType } from '~/pages/IncomeCalculator/Pages/Calculate/types';

export default function IncomeCalculatorAuditHistoryV2() {
  const { lenderDatabaseId, loanRecordId, calculatorType } = useParams();
  const [searchParams] = useSearchParams();
  const pageEnum = `Calculate_${calculatorType}`;

  const { data, isLoading, isError } = useQuery({
    queryKey: [
      'audit-history',
      'income',
      'calculate',
      calculatorType,
      searchParams.get('customerRecordId') ?? searchParams.get('addressId'),
      searchParams.get('employerId'),
    ],
    async queryFn() {
      if (searchParams.get('employerId')) {
        return (
          await typedApiClient.v1.incomeCalculatorEmployersCalculationsAuditList(
            +lenderDatabaseId,
            +loanRecordId,
            +searchParams.get('customerRecordId'),
            +searchParams.get('employerId'),
            calculatorType as CalculatorType,
          )
        ).data;
      } else if (searchParams.get('addressId')) {
        return (
          await typedApiClient.v1.incomeCalculatorPropertiesCalculationsAuditList(
            +lenderDatabaseId,
            +loanRecordId,
            +searchParams.get('addressId'),
            calculatorType as CalculatorType,
          )
        ).data;
      }
      throw new Error();
    },
  });

  return (
    <Layout
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={!data?.length}
      pageEnum={PageTitleMap[pageEnum] ? pageEnum : 'INCOME'}
    >
      <AuditHistorySections sections={data} />
    </Layout>
  );
}
